module.exports = __webpack_public_path__ + "static/media/film-grain.69680209.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/film-grain.gif
// module id = 1791
// module chunks = 0